module.exports = __webpack_public_path__ + "static/media/recorrido25k.275f7d4a.webp";